module.exports = __webpack_public_path__ + "img/data-server-3.da9e168.png";